// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"60":"a7d27d78","474":"22399d47"}[chunkId] + ".chunk.css";
};